import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiError, shopApi, useShop } from "./ShopContext";

// Google return: /shop/account#session_id=... -> exchange once, then go on.
export const ShopAuthCallback = () => {
  const { signIn } = useShop();
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    shopApi.post("/auth/google/session", null, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        signIn(data.token, data.customer);
        const next = sessionStorage.getItem("shop_after_login") || "/shop/account";
        sessionStorage.removeItem("shop_after_login");
        navigate(next, { replace: true });
      })
      .catch((e) => { toast.error(apiError(e, "Google sign-in failed")); navigate("/shop/login", { replace: true }); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#D96B27]" /></div>;
};

export const ShopResetPassword = () => {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await shopApi.post("/auth/reset-password", { token: params.get("token"), password: pw });
      toast.success("Password changed. Please sign in.");
      navigate("/shop/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="mx-auto max-w-md space-y-4 rounded-2xl border bg-white p-6" data-testid="shop-reset-page">
      <h1 className="text-2xl font-extrabold">Choose a new password</h1>
      <input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 8 characters" className="w-full rounded-lg border px-3 py-2.5" data-testid="shop-reset-password-input" />
      <button type="submit" disabled={busy} className="w-full rounded-full bg-[#D96B27] py-3 font-bold text-white" data-testid="shop-reset-submit">Save password</button>
      <Link to="/shop/login" className="block text-center text-sm text-slate-500">Back to sign in</Link>
    </form>
  );
};
